import React from "react";
import { reporteChequeoTableUi as S } from "./reporteChequeoTableUi.ts";

const RowLoading = ({ colSpan = 8 }: { colSpan?: number }) => {
  return (
    <tr>
      {Array.from({ length: colSpan }).map((_, i) => (
        <td key={i} style={S.td}>
          <p className="card-text placeholder-glow mb-0">
            <span className="placeholder col-8" />
          </p>
        </td>
      ))}
    </tr>
  );
};

export default RowLoading;
